import { c as _c } from "react/compiler-runtime";
const Close = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="m36.374 8.797 2.829 2.829L26.828 24l12.375 12.374-2.829 2.829L24 26.828 11.626 39.203l-2.829-2.829L21.172 24 8.797 11.626l2.829-2.829L24 21.172 36.374 8.797z" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Close;